(() => {
  const rootEl = document.documentElement;
  const cardMode = rootEl.dataset.terkProductCardFit || 'smart';
  const pageMode = rootEl.dataset.terkProductPageFit || 'contain';

  const applySmart = (img, mode) => {
    if (!img || img.dataset.terkFitReady === 'true') return;
    const run = () => {
      img.dataset.terkFitReady = 'true';
      img.classList.remove('terk-smart-fill','terk-smart-safe');
      if (mode !== 'smart') return;
      const w = img.naturalWidth || 0;
      const h = img.naturalHeight || 0;
      if (!w || !h) return;
      const ratio = w / h;
      // Premium target is 4:5 = 0.8. Allow close portrait sources to fill fully.
      if (ratio >= 0.74 && ratio <= 0.87) img.classList.add('terk-smart-fill');
      else img.classList.add('terk-smart-safe');
    };
    if (img.complete) run(); else img.addEventListener('load', run, { once:true });
  };

  const normalize = (scope=document) => {
    scope.querySelectorAll('.product-card-wrapper .media img, .product-card-wrapper .card__media img')
      .forEach(img => applySmart(img, cardMode));
    scope.querySelectorAll('.product__media img, .product__media-wrapper img, .product-media-container img')
      .forEach(img => applySmart(img, pageMode));
  };

  const init = () => {
    normalize();
    const observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType !== 1) return;
          if (node.matches?.('img')) {
            const card = node.closest('.product-card-wrapper');
            const page = node.closest('.product__media, .product__media-wrapper, .product-media-container');
            if (card) applySmart(node, cardMode);
            if (page) applySmart(node, pageMode);
          }
          normalize(node);
        });
      }
    });
    observer.observe(document.documentElement,{childList:true,subtree:true});
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})();
